/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import {
  applyHideMarketOptimistic,
  isContentBlockingAffectedQuery,
  reconcileHiddenMarketResponse,
} from '../../helpers/content-blocking.js';
import type { HideMarketResponse, HideMarketVars } from '../openapi-types.gen.js';

export type { HideMarketResponse, HideMarketVars } from '../openapi-types.gen.js';

export const useHideMarket = createMutationHook<HideMarketVars, HideMarketResponse, unknown>({
  specName: 'useHideMarket',
  path: '/v1/hidden-markets/{marketPubkey}',
  method: 'PUT',
  resolveUrl: (vars: HideMarketVars) => `/v1/hidden-markets/${vars.marketPubkey}`,
  
  parseResponse: (raw: unknown): HideMarketResponse => raw as HideMarketResponse,
  optimistic: [
    {
      queryKey: [],
      predicate: isContentBlockingAffectedQuery,
      reconcile: false,
      apply: (prev: unknown, vars: HideMarketVars, queryKey: readonly unknown[]) =>
        applyHideMarketOptimistic(prev, vars, queryKey),
    }, {
    queryKey: ['hidden-markets', 'detail'],
    apply: (prev: any, vars: HideMarketVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['hidden-markets', 'list'],
    apply: (prev: any, vars: HideMarketVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"hidden","targetArg":"marketPubkey","active":true} as const,
  onSuccess: (response: HideMarketResponse, vars: HideMarketVars, queryClient) =>
    reconcileHiddenMarketResponse(queryClient, response, vars),
});
